
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/page", function() {
      var page = require("/Users/andym/Development/Active/Website/pages/page.js")
      if(module.hot) {
        module.hot.accept("/Users/andym/Development/Active/Website/pages/page.js", function() {
          if(!next.router.components["/page"]) return
          var updatedPage = require("/Users/andym/Development/Active/Website/pages/page.js")
          next.router.update("/page", updatedPage.default || updatedPage)
        })
      }
      return { page: page.default || page }
    }]);
  